import { Draggable, Droppable } from "@hello-pangea/dnd";
import "./UiBlockPanel.scss";

export default function UiBlockPanel(props) {
  return (
    <div className="left-components">
      <h3 className="components-title">
        Položky formulára
      </h3>
      <Droppable
        droppableId="uiBlocks-list"
        type="field"
        renderClone={(provided, snapshot, rubric) => {
          const field = props.uiBlocks[rubric.source.index];
          return (
            <div
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              className="ui-block dnd-clone-pos"
              style={{
                ...provided.draggableProps.style,
              }}
            >
              {field.title}
            </div>
          );
        }}
      >
        {(provided) => (
          <div
            ref={provided.innerRef}
            className="left-panel"
            {...provided.droppableProps}
          >
            {props.uiBlocks.map((field, index) => {
              if (field && field.type !== "title") {
                return (
                  <Draggable
                    key={field.field}
                    draggableId={field.field}
                    index={index}
                    type="field"
                  >
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        className="ui-block"
                        style={{
                          ...provided.draggableProps.style,
                          top: "unset",
                          left: "unset",
                        }}
                      >
                        {field.title}
                      </div>
                    )}
                  </Draggable>
                );
              }
              return null;
            })}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </div>
  );
}
